import React from 'react'
import { Toast } from 'react-bootstrap'

/**
 * Open a bootstrap Toast indicating a fatal error
 * @param {any} showAlertMessage hook to enable or disable the alert message window
 * @param {any} closeAlert handles closing of the message by user interaction
 * @param {string} [message] string representing a specialized alert message
 */
const AlertMessage = ({ showAlertMessage, closeAlert, message = "" }) => {
    return (
        <div className="alert-div-wrapper" >
            <div className="alert-div">
                <Toast show={showAlertMessage} onClose={closeAlert} className="alert-message">
                    <Toast.Header>
                        <strong className="mr-auto">{window.i18n('error')}</strong>
                    </Toast.Header>
                    <Toast.Body>{message != "" ? message : window.i18n('errorMessage')}</Toast.Body>
                </Toast>
            </div>
        </div>
    )
}

export default AlertMessage